export const environment = {
  production: false,
  enable_test_ui: false,
  base_url: 'https://testapi.payarc.net/v1',
  googleAnalyticsId: '',
  branding_manifest_ttl_ms: 300000, // 5 minutes
  branding_url: 'https://payarc-branding-preprod.s3.us-east-2.amazonaws.com/',
  partnerHubUrl: 'https://partnerhub.payarc.net/login'
};
